<p-dropdown
  [ngModel]="internalValue"
  (ngModelChange)="onSelectionChange($event)"
  [options]="_groupedOptions"
  optionLabel="label"
  optionValue="value"
  optionGroupLabel="label"
  optionGroupChildren="items"
  [group]="true"
  [placeholder]="placeholder"
  [disabled]="disabled"
  [showClear]="true"
  [filter]="true"
  filterBy="label"
  [filterPlaceholder]="searchPlaceholder"
  styleClass="pcd-trigger"
  panelStyleClass="pcd-panel"
  appendTo="body"
  [baseZIndex]="10000"
>
  <ng-template pTemplate="selectedItem" let-opt>
    <div class="pcd-sel">
      <span class="pcd-sel__name">{{ opt.label }}</span>
      <div class="pcd-sel__badges">
        <span class="pcd-badge pcd-badge--{{ opt.status }}">{{ getCampaignStatusLabel(opt.status) }}</span>
        <span class="pcd-badge pcd-badge--{{ opt.type }}" *ngIf="opt.type">
          <lucide-icon [name]="getCampaignTypeIcon(opt.type)" [size]="9"></lucide-icon>
          {{ getCampaignTypeLabel(opt.type) }}
        </span>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="group" let-group>
    <div class="pcd-group-header">{{ group.label }}</div>
  </ng-template>

  <ng-template pTemplate="item" let-opt>
    <div class="pcd-opt">
      <span class="pcd-opt__name">{{ opt.label }}</span>
      <div class="pcd-opt__badges">
        <span class="pcd-badge pcd-badge--{{ opt.status }}">{{ getCampaignStatusLabel(opt.status) }}</span>
        <span class="pcd-badge pcd-badge--{{ opt.type }}" *ngIf="opt.type">
          <lucide-icon [name]="getCampaignTypeIcon(opt.type)" [size]="9"></lucide-icon>
          {{ getCampaignTypeLabel(opt.type) }}
        </span>
      </div>
    </div>
  </ng-template>
</p-dropdown>
